import React, { useState, useEffect } from 'react'
import Table from 'react-bootstrap/Table'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import StandingsRank from './StandingsRank'
import TeamStandingsAngler from './TeamStandingsAngler'
import StandingsTotal from './StandingsTotal'
import TeamStandingsHeader from './TeamStandingsHeader'
import StandingsFishScores from './StandingsFishScores'
import StandingsKey from './StandingsKey'
import TeamStandingsKey from './TeamStandingsKey'
import TeamStandingsTotal from './TeamStandingsTotal'
import TeamStandingsTeamTab from './TeamStandingsTeamTab'
import TeamStandingsTeamScores from './TeamStandingsTeamScores'

import * as txApi from '../clients/tx-sls-client'

const TeamStandings = ({tournamentId, details, user_information,hash, hideProfileLink = false, noAutoScroll = false, providedStandings = undefined}) => {
    const tournamentDetails = details
    //console.log('tournamentDetails found for selected TEAM TYPE tournament::',tournamentDetails);
    const [fullStandings, setFullStandings] = useState({
      tournamentId : '',
      days : {}
    })
    const [rows, setRows] = useState(175)
    const [standings, setStandings] = useState([])
    const [maxFish, setMaxFish] = useState(5)
    const [currentDay, setCurrentDay] = useState(1)
    const [loading, setLoading] = useState(false)
    const [scrollTo, setScrollTo] = useState(hash)

     //Naveen 27/Dec/2023::TP-349 added if condition for tourney_type 19 
    if(tournamentDetails && tournamentDetails.tourney_type == 3 || ( tournamentDetails.tourney_type == 19  && tournamentDetails.is_fish_count_per_event != 1 )){
        var totalDays = tournamentDetails.marathon_days;
      }else{
        if(tournamentDetails &&  ( tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16)){
            var totalDays = 2;
        }else{
          // For regular,custom type tournaments.  
          var totalDays = 1;
        }
       
    }

    //console.log('totalDays output calculated:::',totalDays);
 
    const scrollToHash = (hash) => {
      if(hash && !noAutoScroll){
        window.location.hash = hash
        const target = hash.replace('#', '')
        const elem = document.getElementById(target)
        if(elem) {
          elem.scrollIntoView(true)
        }
      }
    }
  
    const isInViewport = (elem) => {
      const bounding = elem.getBoundingClientRect();
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };


    const handleScroll = () => {
        if((!standings || standings.length === 0 || standings.length === rows) || tournamentDetails.show_standings === '0'){
          if( ( user_information && user_information.role === '1') || ( user_information && user_information.user_id === tournamentDetails.user_id )  ){

            // Do nothing, allow super-admin and tourney director to scroll through records

          }else{

              // Check if logged in user is assigned as a judge, then allow him to scroll through records

              if((tournamentDetails.judge_list && tournamentDetails.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( user_information && user_information.user_id) > -1) == true ) ){

                  // Do nothing, allow judge to scroll through records

              }else{
                  return;
              }
              
          } 
        }
           
    
        if(isInViewport(document.querySelector('#standings-footer'))) {
          console.log(`scrolling... row value set`, rows, 'standings length response::', standings.length)
          if(standings.length < rows + 25) {
            setRows(standings.length)
          } else {
            setRows(rows => rows + 25)
          }
        }
    }

    const updateFields = (results, maxFish) => {
        setStandings(results)
        setMaxFish(maxFish) 
        //console.log('maxFish value set::',maxFish);
        //console.log('results value set:::',results);
    }

    const handleStandings = (standings) => {
       
        const template = {
          tournamentId : tournamentId,
          maxFish : tournamentDetails.maxFish
        }

        // Check if results length is greter than 1, if YES, then show tab layout view

        const standingsResult = (standings.results.length > 1) 
        ? standings.results
        : standings.results[0]

        const updatedFullStandings = {...template, days : standingsResult}
        
        setFullStandings(updatedFullStandings)

        console.log('updatedFullStandings value :::', updatedFullStandings);
        console.log('TeamTYPE-tournamentDetails response ::', tournamentDetails);

        // Check for team-type tournament, to set the total_fish or total_fish_per_team value
        if(tournamentDetails && (tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16 ) ){
         
          
          if( tournamentDetails.total_fish !== null){
            var regularTourneyMaxFishPerAnglerTeamType = parseInt(tournamentDetails.total_fish);
          }else{
            regularTourneyMaxFishPerAnglerTeamType = parseInt(tournamentDetails.total_fish_per_team);
           
          }

          updateFields(updatedFullStandings.days[currentDay], regularTourneyMaxFishPerAnglerTeamType)

        }
    }

    const stopLoading = () => {
        setLoading(false)
        if(scrollTo) {
          scrollToHash(scrollTo)
        }
    }

    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, [standings]);

    useEffect(() => {
        setLoading(true)
        setRows(175)
    
        if(fullStandings.tournamentId === tournamentId && fullStandings.days[currentDay] !== undefined) {
          console.log('using react cache')
          
          console.log('fullTeamStandings output:::', fullStandings);
    
          
          if(tournamentDetails && (tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16 ) ){
            if(tournamentDetails.total_fish !== null){
              var currentDayMaxFish = tournamentDetails.total_fish;
            }else{
              var currentDayMaxFish = tournamentDetails.total_fish_per_team;
            }
          }
          
    
          updateFields(fullStandings.days[currentDay], currentDayMaxFish)
          if(scrollTo) {
            scrollToHash(scrollTo)
          }
          setLoading(false)
        } else {
          if(providedStandings) {
            handleStandings(providedStandings)
            stopLoading()
          } else {
            txApi.getTeamStandings(tournamentId)
              .then(standings => 
             {          
                console.log('standings response:::',standings)
                handleStandings(standings) })
              .catch(error => {
                console.error(`Error loading standings for day ${currentDay}: ${error}`)
                setStandings([])
              })
              .finally(() => stopLoading())
          }
        }
    }, [tournamentId, currentDay, tournamentDetails])

    const createTabs = (totalDays) => {
        let tabs = [];
      if(tournamentDetails && tournamentDetails.tourney_type == 4 ){
        tabs.push(<Tab eventKey="1" title='Team leaderboard'></Tab>)
      }else{
        tabs.push(<Tab eventKey="1" title='Mini-Matches leaderboard'></Tab>)
      }

      tabs.push(<Tab eventKey="0" title='Angler leaderboard'></Tab>)
    
        return tabs;
    }
    return (
        <>
        <div className='standings-link'><a id="scores" name="scores"/></div>   

        { loading ?
            <div className="loading" /> 
            :
            
            // Check if standings data is present, else show No submissions message
            // Change added on 03-16-2021
           
           
           <div>

           { 
               (totalDays > 1) ?
               <Tabs id="tabs" activeKey={currentDay}  onSelect={d => {setCurrentDay(d);setScrollTo(`#scores`)}}>
               {createTabs(totalDays)}
               </Tabs>
               : <div></div>
           }
          {
            // Following div is for mobile view handling
          }
          <div className="d-sm-none">
            {
                  // Check if standings record is present, then only show the standings data, else show No submissions to show message
                
                  //(standings && standings.length > 0 ) ? 
                  currentDay === '0'
                  ? <StandingsKey anglers={standings ? standings.length : 0 } fishCaught={tournamentDetails.total_fish_caught} /> 
                  : <TeamStandingsKey teams={standings ? standings.length : 0 } /> 
            }

            {
                currentDay === '0'
                ?
                <Table responsive hover striped>
             
                <TeamStandingsHeader numberOfFish={maxFish} hideFish='true' showDays={currentDay === '0'} showDays='false'  days={totalDays} day={currentDay}/>
                <tbody>
                  {
                    currentDay === '0'
                    ?
                    ( standings && standings.length > 0) ? standings.map((standing, index) => 
                    <>
                    
                    <tr>
                   
                      <StandingsRank rank={index+1} key={`lgrank${index}`}/>

                      <TeamStandingsAngler angler={standing} user_information={user_information} key={`lgangler${index}`}  hideProfileLink={hideProfileLink}/>

                      <StandingsTotal  total_length={standing.total_fish_length ? standing.total_fish_length : 0} total_weight={standing.total_fish_weight ? standing.total_fish_weight : 0} day_wise_fish_records = { standing.day_wise_fish_records  } culled_fish_records = { standing.culled_fish_records } tourney_type = {tournamentDetails.tourney_type} fish_caught = {standing.fish_caught} top_max_fish_length={standing.top_max_fish_length} top_max_fish_weight={standing.top_max_fish_weight} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish}  key={`total${index}`} showDropdown='true' length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} estimated_total_fish_weight = {standing?.estimated_total_fish_weight ? standing.estimated_total_fish_weight : ''} scoresId={'scores'+index}/>
                   
                    </tr>
                    <tr id={'scores'+index} className='hidden'>
                      <td colSpan='3'>
                       <Table key={`scoresRow${index}`}>
                        <tbody>
                          <tr>
                            { 
                            
                              currentDay === '0' 
                                ? <StandingsFishScores submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} user_information={user_information} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} key={`score${index}`} colSpan='3'/>
                                : <h5 className="no-show">No Submissions To Show</h5>
                            }
                          </tr>
                        </tbody>
                       </Table>
                      </td> 
                    </tr>


                    </>
                    )
                   
                    : <tr><td colSpan={maxFish + 3}></td></tr>
                    :null
                    
                    
                  }
                </tbody>
                </Table>
                :
                <Table responsive hover striped>
                        <TeamStandingsHeader numberOfFish={0}  showDays='false'  day={1}/>
                        <tbody>
                          {
                            standings ? standings.map((standing, index) => 
                            <tr>
                                <StandingsRank rank={index+1} key={`lgrank${index}`}/>
                                <TeamStandingsTeamTab angler={standing} key={`lgangler${index}`}  hideAnglerRecord='false'/>
                                <TeamStandingsTotal total_length={standing.total ? standing.total : 0}  measurement_type= {tournamentDetails.measurement_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} key={`total${index}`}/>
                            </tr>
                            )
                            :null
                            
                          }
                          
                        </tbody>
                </Table>
          }
          </div>
          {
            //Mobile browser view div has ended
          }



          {
            //Following div is for browser view handling
          }

          <div className="d-none d-sm-block">
            {
                  // Check if standings record is present, then only show the standings data, else show No submissions to show message
                
                  //(standings && standings.length > 0 ) ? 
                  currentDay === '0'
                  ? <StandingsKey anglers={standings ? standings.length : 0 } fishCaught={tournamentDetails.total_fish_caught} /> 
                  : <TeamStandingsKey teams={standings ? standings.length : 0 } /> 
            }
            {
                currentDay === '0'
                ?
                <Table responsive hover striped>
             
                <TeamStandingsHeader numberOfFish={maxFish} showDays={currentDay === '0'} showDays='false'  days={totalDays} day={currentDay}/>
                <tbody>
                  {
                    currentDay === '0'
                    ?
                    ( standings && standings.length > 0) ? standings.map((standing, index) => 
                    <tr>
                   
                      <StandingsRank rank={index+1} key={`lgrank${index}`}/>

                      <TeamStandingsAngler angler={standing} user_information={user_information} key={`lgangler${index}`}  hideProfileLink={hideProfileLink}/>

                      { 
                            
                            currentDay === '0' 
                                ? <StandingsFishScores submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} user_information={user_information} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} key={`score${index}`} colSpan='3'/>
                                : <h5 className="no-show">No Submissions To Show</h5>
                      }
                      <StandingsTotal total_length={standing.total_fish_length ? standing.total_fish_length : 0} total_weight={standing.total_fish_weight ? standing.total_fish_weight : 0} day_wise_fish_records = { standing.day_wise_fish_records  } culled_fish_records = { standing.culled_fish_records } tourney_type = {tournamentDetails.tourney_type} fish_caught = {standing.fish_caught} top_max_fish_length={standing.top_max_fish_length} top_max_fish_weight={standing.top_max_fish_weight} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} estimated_total_fish_weight = {standing?.estimated_total_fish_weight ? standing.estimated_total_fish_weight : ''} key={`total${index}`} />
                        
                    </tr>
                    )
                   
                    : <tr><td colSpan={maxFish + 3}></td></tr>
                    :null
                    
                    
                  }
                </tbody>
                </Table>
                :
                <Table responsive hover striped>
                        <TeamStandingsHeader numberOfFish={maxFish} hideFish='true'  showDays='false'  day={1} team_record_total={parseInt(tournamentDetails.number_of_anglers)} />
                        <tbody>
                        {
                           standings ? standings.map((standing, index) => 
                           <tr>
                              <StandingsRank rank={index+1} key={`lgrank${index}`}/>
                             
                              <TeamStandingsTeamTab angler={standing} key={`lgangler${index}`}  hideAnglerRecord='false'/>
                              { 
                            
                                <TeamStandingsTeamScores team_standings={standing.angler_list} measurement_type= {tournamentDetails.measurement_type} key={`score${index}`} hideTeamAnglerRecord='false' colSpan={parseInt(tournamentDetails.number_of_anglers)} length_measurement_symbol = {tournamentDetails.length_unit}  weight_measurement_symbol = {tournamentDetails.weight_unit} team_angler_totals = {standing.angler_totals ? standing.angler_totals : null}/>
                             
                              }
                              <TeamStandingsTotal total_length={standing.total ? standing.total : 0}  measurement_type= {tournamentDetails.measurement_type} length_measurement_symbol = {tournamentDetails.length_unit}  weight_measurement_symbol = {tournamentDetails.weight_unit} key={`total${index}`} />
                           </tr>
                           )
                           :null
                          
                        }
                       
                        </tbody>
                </Table>
            }
          </div>

          </div>
          // End of standings parent div
          
        
        }
        
        <div id='standings-footer' />


        </>
    )


}

export default TeamStandings